import { VuexModule } from "vuex-class-modules";
import Axios from "axios";
import { configureOidc } from "../services/security.service";
import { Log } from "../../plugins/Logging";

export default class AxiosSecureModule extends VuexModule {
    async defineHeaderAxios() {
        await configureOidc().then(
            (oidc) => {
                Axios.defaults.headers.common["Authorization"] =
                    "Bearer " + oidc.accessToken;
            },
            (err) => {
                Log.error("", err);
            }
        );
    }
}
